/* eslint-disable react-hooks/exhaustive-deps */
import { SimpleWrapper } from "components/InputsMex/containers";
import { TextInputOnBlur } from "components/InputsMex/inputs";
import React, { useState } from "react";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Button as BtnInfo } from "primereact/button";

export const CheckCompuesto = ({
    name = "",
    label = "",
    defaultValue = false,
    disabled = false,
    extrasClasses = '',
    habilitaCampo = false,
    nameInfo = '',
    nodoCheck = 'selecciono',
    estructura = false,
    inputProps,
    checkClassName = 'mr-5 p-0',
    labelClassName = "",
    labelFontSize = "20px",
    labelFontFamily = "Futura-Medium",
    colLabelSize = "col-5",
    tooltip
}) => {
    const methods = useFormContext();
    const [showCampo, setShowCampo] = useState(false)

    const htmlMessage = (mssg, fontSize = "15px") => {
        return (

            <div
                style={{ fontSize: `${fontSize}`, fontFamily: `${labelFontFamily}` }}
                className={`${labelClassName}`}
            >
                {mssg}
                {
                    tooltip != null &&
                    <BtnInfo
                        type='button'
                        style={{ borderRadius: "25%" }}
                        className='p-button-text p-button-plain mx-3 p-0 font-20px'
                        tooltip={tooltip ?? ""}>
                        <i className='pi pi-question-circle' style={{ fontSize: "1.7rem" }} />
                    </BtnInfo>
                }
            </div>


        );
    };


    useEffect(() => {
        habilitaCampo && setShowCampo(methods.getValues(name)?.[nodoCheck] || defaultValue);
        methods.setValue(name, estructura ?
            {
                ...estructura,
                [nodoCheck]: methods.getValues(name)?.[nodoCheck] || defaultValue
            } :
            methods.getValues(name)?.[nodoCheck] || defaultValue);
    }, [])

    return (
        <>
            <div className={'col-12 d-flex flex-wrap justify-content-around ' + extrasClasses}>

                <div className='col-12 d-flex flex-wrap py-3'>
                    <div className={`${habilitaCampo ? `${colLabelSize}` : 'col-12'} d-flex align-items-center justify-content-start px-0 mx-0`}>
                        <label className={`${checkClassName}`}>
                            <Controller
                                name={name}
                                defaultValue={false}
                                render={({ value }) => (
                                    <input
                                        name={name}
                                        type='checkbox'
                                        className="chek-terminos"
                                        disabled={disabled}
                                        checked={estructura ? value?.[nodoCheck] : !!value}
                                        onChange={() => {
                                            methods.setValue(name, estructura ? { ...estructura, [nodoCheck]: !value?.[nodoCheck] } : !value);
                                            habilitaCampo && setShowCampo(!value?.[nodoCheck]);
                                        }}
                                    />
                                )}
                            />

                        </label>
                        {htmlMessage(label, labelFontSize)}

                    </div>

                    <div className="d-flex col-6 align-items-start m-2">
                        {habilitaCampo && showCampo && <SimpleWrapper extrasClasses={'hidden'} name={nameInfo} showOk={false}>
                            <TextInputOnBlur
                                inputProps={{
                                    name: nameInfo,
                                    type: inputProps.type
                                }}
                                prefijo={inputProps.prefijo}
                                numerico={inputProps.numerico}
                                rules={{
                                    required: 'Este campo es obligatorio',
                                    validate: inputProps.rules
                                }}
                                extrasClasses="hide-arrows"
                            />
                        </SimpleWrapper>}
                    </div>
                </div>
            </div>
        </>
    );
};

CheckCompuesto.defaultProps = {
    inputProps: {
        type: "text",
        rules: {},
        numerico: false,
        prefijo: ''
    }
}